import { z } from 'zod';

export const schemaConsorsSubscriberIdentifierExternal = z
    .string()
    .min(0)
    .max(50)
    .regex(/^[0-9a-zA-ZÃŸÃ¤Ã Ã¼Ã–Ã„Ãœ -ÃŸäöüÄÖÜßáéíóúÁÉÍÓÚñÑãÃ]*$/, 'Invalid characters');
